var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImpersonateUserButton',{attrs:{"email":_vm.ownerEmail,"target-route":_vm.previewLink,"tooltip":"View in recordings"}})
}
var staticRenderFns = []

export { render, staticRenderFns }